<p-button
    [id]="id() + '-btn'"
    [type]="'button'"
    [severity]="severity()"
    [icon]="isSvgIcon ? '' : this.icon()"
    [disabled]="disabled()"
    [loading]="loading()"
    [rounded]="rounded()"
    [text]="text()"
    [outlined]="outlined()"
    [size]="size()"
    [styleClass]="class()"
    [pTooltip]="tooltip() | translate"
    [tooltipPosition]="tooltipPosition()"
    [tooltipDisabled]="tooltipDisabled()"
    [attr.aria-disabled]="disabled()"
    [attr.aria-label]="ariaLabel() | translate"
    (onClick)="onClick.emit($event); $event.stopPropagation()"
    [class]="isSvgIcon ? 'p-button-icon-svg' : ''">
    @if (isSvgIcon) {
        <img [src]="icon()" [alt]="ariaLabel()" [style.width]="'35px'" />
    }
    <ng-content></ng-content>
</p-button>
